import { Link as MaterialLink, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import useStyles from '@components/common/sign-in-form/styles';
import useTypedSelector from '@hooks/use-typed-selector';
import { UserDataForLogin } from '@lib/api';
import { signIn } from '@store/auth/thunks';
import Validation from '@utils/validation';

import Button from '../button';
import Field from '../field';

const signInValidation = Yup.object().shape({
  email: Validation.emailRequired,
  password: Validation.required,
});

interface Props {
  isLoading: boolean;
}

const SignInForm: React.FC<Props> = (props) => {
  const { isLoading } = props;

  const { error } = useTypedSelector((state) => state.auth);

  const dispatch = useDispatch();

  const classes = useStyles();

  const onSubmit = (data: UserDataForLogin) => {
    dispatch(signIn(data));
  };

  return (
    <section>
      <section>
        <Typography
          component="h1"
          variant="subtitle1"
          className={classes.title}
        >
          Making a will is easy.
        </Typography>
      </section>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        onSubmit={onSubmit}
        validationSchema={signInValidation}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className={classes.inputWrapper}>
              <Field
                id="email-sign-in"
                type="email"
                placeholder="Your email address"
                label="Your email address"
                variant="filled"
                name="email"
                value={values.email}
                onChange={handleChange}
                errorMessage={errors.email}
                redOutline={error ? true : undefined}
              />
            </div>
            <div className={classes.inputWrapper}>
              <Field
                showHidePassword
                id="password-sign-in"
                type="password"
                placeholder="Password"
                label="Password"
                variant="filled"
                name="password"
                value={values.password}
                onChange={handleChange}
                errorMessage={errors.password}
                redOutline={error ? true : undefined}
              />
            </div>
            <div className={classes.textRight}>
              <Link href="/reset-password" passHref>
                <MaterialLink
                  id="reset-password"
                  className={classes.resetPassword}
                >
                  Reset password
                </MaterialLink>
              </Link>
            </div>
            <Button
              id="sign-in-button"
              type="submit"
              styleType="containedBlue"
              text="Sign in"
              className={classes.submitButton}
              disabled={isLoading}
              isLoading={isLoading}
            />
          </form>
        )}
      </Formik>
      <section>
        <Typography variant="body2" className={classes.greyText}>
          Don&apos;t have an account?{' '}
          <Link href="/sign-up" passHref>
            <MaterialLink id="register-link" className={classes.blueText}>
              Register
            </MaterialLink>
          </Link>
        </Typography>
      </section>
    </section>
  );
};

export default SignInForm;
